<template>
  <InfoModal
    :is-disabled="isLoading"
    :show-close-btn="!isLoading"
    :is-loading="isLoading"
    title="Ansökan är inaktiv"
    mobile-full-width
    @click="$emit('response', 'CLOSE')"
  >
    <div class="wrapper">
      <template v-if="isOwner">
        <h2>Din ansökan har blivit inaktiv</h2>
        <p>
          Det var ett tag sedan du var aktiv och vi har därför inaktiverat
          ansökan. Detta gör vi för att säkerställa att informationen i din
          ansökan är aktuell och relevant.
        </p>
        <h2>Vill du återaktivera din ansökan?</h2>
        <p>
          Du kan när som helst återaktivera din ansökan för att fortsätta där du
          slutade. All information du tidigare angett finns kvar och du kan
          enkelt gå vidare i processen.
        </p>
        <BaseButton
          :is-rounded="true"
          type="button"
          :is-small="true"
          :is-disabled="isLoading"
          :is-loading="isLoading"
          :is-fullwidth="isMobile"
          @click="$emit('response', 'RE_ACTIVATE')"
          ><BaseIconText :icon-url="svgs.ICONS.ARROW_RIGHT" :align-right="true">
            Återaktivera ansökan
          </BaseIconText>
        </BaseButton>
      </template>
      <template v-else>
        <h2>Inaktiv ansökan</h2>
        <p>
          Det var ett tag sedan ni var aktiva och vi har därför inaktiverat
          ansökan. Detta gör vi för att säkerställa att informationen är aktuell
          och relevant.
        </p>
        <h2>Vill du återaktivera ansökan?</h2>
        <p>
          Du har inte möjlighet att återaktivera ansökan, däremot kan personen
          som initierade ansökan göra detta. All information ni tidigare angett
          finns kvar och ni kan enkelt gå vidare i processen.
        </p>
      </template>
    </div>
  </InfoModal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import svgs from '@/utils/icon-constants';

import InfoModal from '@/components/InfoModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIconText from '@/components/BaseIconText.vue';

export default {
  name: 'ReActivateAhApplication',
  components: {
    InfoModal,
    BaseButton,
    BaseIconText
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      svgs
    };
  },
  computed: {
    ...mapState({
      application: state => state.subletApplication.application
    }),
    ...mapGetters({
      isMobile: 'app/isMobile'
    })
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  h2 {
    margin: 0 0 0rem;
  }
  p {
    margin: 0 0 2rem;
    line-height: 1.6;
  }
  > *:nth-last-child(1) {
    margin: 0;
  }
}
</style>
